import PropTypes from 'prop-types'
import React from 'react'
import { findDOMNode } from 'react-dom'
import { uncontrollable } from 'uncontrollable'
import scrollIntoView from 'scroll-into-view-if-needed'
import {
  ToggleModal
} from 'components/Modal'
import Form from './Form'
import classes from './EditableModal.module.scss'

export class EditableModal extends React.Component {
  static propTypes = {
    isEditing: PropTypes.bool.isRequired,
    onIsEditingChange: PropTypes.func.isRequired,

    onSubmit: PropTypes.func.isRequired,
    textarea: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.bool
    ]),
    buttons: PropTypes.func,
    form: PropTypes.string,
    saveChanges: PropTypes.bool,
    validate: PropTypes.func,
    initialValues: PropTypes.object,
    submitOnEnter: PropTypes.bool,
  }

  static defaultProps = {
    form: 'editable',
    saveChanges: false
  }

  componentDidMount () {
    if (this.props.isEditing) {
      this.scrollIntoView()
    }
  }

  componentDidUpdate (prevProps) {
    if (this.props.isEditing && !prevProps.isEditing) {
      this.scrollIntoView()
    }
  }

  componentWillUnmount () {
    cancelAnimationFrame(this.requestedFrame)
  }

  scrollIntoView = () => {
    cancelAnimationFrame(this.requestedFrame)
    this.requestedFrame = requestAnimationFrame(() => {
      scrollIntoView(findDOMNode(this), {
        scrollMode: 'if-needed',
        block: 'nearest'
      })
    })
  }

  close = () => {
    this.props.onIsEditingChange(false)
  }

  handleModalRef = (ref) => {
    if (ref) ref.style.width = findDOMNode(this).offsetWidth + 'px'
  }

  handleClick = (event) => {
    event.stopPropagation()
  }

  handleFormSubmit = (...args) => {
    const { onSubmit } = this.props

    this.close()

    return onSubmit(...args)
  }

  makeClickable = (element) => {
    return React.cloneElement(element, { onClick: this.open })
  }

  renderChildren = (children) => {
    if (typeof children === 'function') {
      return children(this.makeClickable)
    } else {
      return this.makeClickable(children)
    }
  }

  render () {
    const {
      children,

      isEditing,
      onIsEditingChange,

      textarea,
      form,
      validate,
      initialValues,

      maxLength,

      submitOnEnter
    } = this.props

    return (
      <ToggleModal
        backdrop
        show={isEditing}
        onToggle={(isEditing) => { onIsEditingChange(isEditing) }}
        attachment='top left'
        targetAttachment='top left'
        constraints={[
          {
            to: 'window',
            pin: true
          }
        ]}
      >
        {this.renderChildren(children)}
        {isEditing &&
          <div
            ref={this.handleModalRef}
            className={classes.modal}
          >
            <Form
              textarea={textarea}
              form={form}
              initialValues={initialValues}
              validate={validate}
              onSubmit={this.handleFormSubmit}
              onCancel={this.close}
              maxLength={maxLength}
              submitOnEnter={submitOnEnter}
            />
          </div>
        }
      </ToggleModal>
    )
  }
}

export default uncontrollable(
  EditableModal,
  {
    isEditing: 'onIsEditingChange'
  }
)
